import { useQuery } from '@tanstack/vue-query'
import api from '@/core/config/axios'
import { TUser } from '@/core/types'

type TLoadAuthOptions = {
  enabled?: boolean
}

export const useLoadAuth = ({ enabled }: TLoadAuthOptions) =>
  useQuery<TUser>({
    queryKey: ['auth-user'],
    queryFn: () => api.get('/v1/auth/user').then((response) => response.data),
    enabled,
  })
